<template>
  <div class="wc-row">
    <div class="wc-col wc-col__sm-12 wc-col__md-12">
      <ChangeBankDataList></ChangeBankDataList>
    </div>
  </div>
</template>

<script setup lang="ts">
import ChangeBankDataList from '@/components/policy/self-services/ChangeBankDataList.vue'
</script>
